import { createContext, ReactNode, useContext, useMemo, useState } from 'react';

type LocationContextType = {
  currentLocation: string;
  setCurrentLocation: (currentLocation: string) => void;
};

export const LocationContext = createContext<LocationContextType | undefined>(
  undefined,
);

export const LocationContextProvider = ({
  children,
}: {
  children: ReactNode;
}) => {
  const [currentLocation, setCurrentLocation] = useState<string>('');

  const value: LocationContextType = useMemo(
    () => ({
      currentLocation,
      setCurrentLocation,
    }),
    [currentLocation],
  );

  return (
    <LocationContext.Provider value={value}>
      {children}
    </LocationContext.Provider>
  );
};

export const useLocationContext = () => {
  const context = useContext(LocationContext);
  if (!context) {
    throw new Error(
      'useLocationContext must be used within LocationContextProvider.',
    );
  }

  return context;
};
